import { render, staticRenderFns } from "./TownsStreetsMonthServiceElder.vue?vue&type=template&id=40390989&scoped=true&"
import script from "./TownsStreetsMonthServiceElder.vue?vue&type=script&lang=js&"
export * from "./TownsStreetsMonthServiceElder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40390989",
  null
  
)

export default component.exports